export default __webpack_public_path__ + "static/ddebit1-fff457fed2b1dc5c0051282581dd21ab.png";